import { DriveFileRenameOutline, Folder } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { DesignList__DesignFolder } from '../DesignList.generated';

export interface StudioMenuDesignFolderProps {
  /** Set by the menu when this is its first child; this component has no element to take it. */
  autoFocus?: boolean;
  item: DesignList__DesignFolder;
  onMove: () => void;
  onRename: () => void;
}

export const StudioMenuDesignFolder = ({
  autoFocus,
  item,
  onMove,
  onRename,
}: StudioMenuDesignFolderProps) => {
  const { t } = useTranslation();

  return (
    <>
      <MenuItem autoFocus={autoFocus} disabled={!item.canUpdate.value} onClick={onMove}>
        <ListItemIcon>
          <Folder />
        </ListItemIcon>
        <ListItemText>{t('pages.studio.list.actions.move_folder')}</ListItemText>
      </MenuItem>
      <MenuItem disabled={!item.canUpdate.value} onClick={onRename}>
        <ListItemIcon>
          <DriveFileRenameOutline />
        </ListItemIcon>
        <ListItemText>{t('pages.studio.list.actions.rename')}</ListItemText>
      </MenuItem>
    </>
  );
};
